import React, { useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import PieChart from 'components/PieChart/PieChart'
import { IReportFilter } from 'views/Reports'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';
import { AccentArea } from 'components'

/**
 * @name ByCardType
 * @desc Render Card Type chart
 * @filterValues IReportsFilter
 */
const ByCardType = ({
    filterValues,
}: {
    filterValues: IReportFilter
}): React.ReactElement => {
    const { clientTheme } = useThemeStyling()
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<{ name: string; value: number }[]>([])

    React.useEffect(() => {
        setLoading(true)
        ReportsApi.getByCardType(filterValues).then((data) => {
            setLoading(false)
            // Filter out the "Others" entry from the data
            const filteredData = data.filter(item => item.name !== 'Others')
            setData(filteredData)
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    const byCardTypeColorPalette =
        clientTheme.charts.pieCharts.defaultPieChart

    return (
        <AccentArea title="Card Type">
            <PieChart
                colorPalette={byCardTypeColorPalette}
                data={data}
                loading={loading}
                testId="byCardType"
                height={350}
                pieLabelLayout={'inside'}
            />
        </AccentArea>
    )
}

export default ByCardType
